import {useAuth} from '@/modules/auth/api'
import {useGetUser} from '@/modules/users/api'
import {getPrescriptionRoles, getUserPermissions, hasPermission, type Permission} from '@cypro/engine/utils'

/**
 * Permissions of the signed-in user, live through Zero so they follow group changes.
 * Reads the user's groups, never a group type.
 */
export function usePermissions() {
  const {auth} = useAuth()
  const [user] = useGetUser(auth?.user?.id)

  const groups = user?.groups

  return {
    permissions: getUserPermissions(groups),
    can: (permission: Permission) => hasPermission(groups, permission),
  }
}

export function useCan(permission: Permission) {
  return usePermissions().can(permission)
}

/** Prescription permissions (edit, validate as doctor/pharmacist, release) for the signed-in user. */
export function usePrescriptionRoles() {
  const {auth} = useAuth()
  const [user] = useGetUser(auth?.user?.id)

  return getPrescriptionRoles(user?.groups)
}
